// "Subject" labels will be used when the action is the subject (grammatically).
// For example, in the segment editor the conditions read as a sentence where
// the action is the subject: "Any push has been opened".
// In the segment viewer, however, the sentences are person-centric, e.g.
// "Segment for people who have opened any push". We need to differentiate
// between "have opened" and "opened" states.
export const FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'converted',
    'bounced',
    'failed',
    'dropped', // we have a name mismatch between UI and bitmaps on the BE: https://github.com/customerio/issues/issues/2124
    'undeliverable',
  ].map((filter) => `${filter}_action`),
);

export const SUBJECT_ACTION_FILTERS = Object.freeze(
  [
    'been sent',
    'been delivered',
    'been opened',
    'been clicked',
    'converted',
    'bounced',
    'failed to send',
    'been suppressed',
    'been marked as undeliverable',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const NON_SUBJECT_ACTION_FILTERS = Object.freeze(
  [
    'been sent',
    'been delivered',
    'opened',
    'clicked',
    'converted',
    'bounced',
    'failed to receive',
    'suppressed',
    'marked as undeliverable',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const IS_SUBJECT_ACTION_FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'converted',
    'bounced',
    'failed to send',
    'suppressed',
    'marked as undeliverable',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);

export const IS_NON_SUBJECT_ACTION_FILTERS = Object.freeze(
  [
    'sent',
    'delivered',
    'opened',
    'clicked',
    'converted',
    'bounced',
    'failed to receive',
    'suppressed',
    'marked as undeliverable',
  ].map((label, index) => {
    return { label, value: FILTERS[index] };
  }),
);
